<script setup>
import { useTrackStore } from "@/stores/TrackStore.js";

const trackStore = useTrackStore();

const props = defineProps({
  track: Object,
});

const selectTrack = function selectTrack() {
  trackStore.selectTrack(props.track);
};
</script>

<template>
  <tr @click="selectTrack" :class="{ 'table-secondary': isSelected, 'tracks-list-item': true }">
    <td style="width: 30% !important">
      <div class="d-flex px-2 py-1 align-items-center">
        <div>
          <img
            class="rounded"
            :src="track.thumbnailUrl"
            width="50"
            height="50"
          />
        </div>
        <div class="ms-3">
          <em>{{ track.artistName }}</em>
          <br />{{ track.title }}
        </div>
      </div>
    </td>
    <td>{{ track.genreNames }}</td>
    <td class="text-center">
      <fa v-if="track.vocal" icon="microphone-alt" />
      <fa v-else icon="microphone-alt-slash" class="text-muted" />
    </td>
    <td class="text-center">{{ track.bpm }}</td>
    <td class="text-center">00:00</td>
    <td @click="toggleFavorited" class="text-center">
      <fa v-if="favorited" icon="heart" />
      <fa v-else :icon="['far', 'heart']" class="text-muted" />
    </td>
  </tr>
</template>
